<template>
  <div class="month-selector">
    <BaseButton
      size="sm"
      variant="secondary"
      @click="previousMonth"
    >
      ◀
    </BaseButton>
    <span class="current-month">
      {{ year }}年 {{ month }}月
    </span>
    <BaseButton
      size="sm"
      variant="secondary"
      @click="nextMonth"
    >
      ▶
    </BaseButton>
  </div>
</template>

<script setup>
import BaseButton from '@/components/atoms/BaseButton.vue'

const props = defineProps({
  year: {
    type: Number,
    required: true
  },
  month: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['update:year', 'update:month', 'change'])

const previousMonth = () => {
  let newMonth = props.month - 1
  let newYear = props.year
  if (newMonth < 1) {
    newMonth = 12
    newYear--
  }
  emit('update:year', newYear)
  emit('update:month', newMonth)
  emit('change', { year: newYear, month: newMonth })
}

const nextMonth = () => {
  let newMonth = props.month + 1
  let newYear = props.year
  if (newMonth > 12) {
    newMonth = 1
    newYear++
  }
  emit('update:year', newYear)
  emit('update:month', newMonth)
  emit('change', { year: newYear, month: newMonth })
}
</script>

<style lang="scss" scoped>
.month-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.current-month {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  min-width: 120px;
  text-align: center;
}

button {
  padding: 0.375rem 0.75rem;
  font-weight: bold;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
}
</style>
